import React, { useState, useEffect, } from "react";

// Styles
import "./styles.scss";

// Assets
import Hero1 from "../../Assets/Images/Banner-01.webp";
import Hero2 from "../../Assets/Images/Banner-02.webp";
import Hero3 from "../../Assets/Images/Banner-03.webp";
import Hero4 from "../../Assets/Images/Banner-04.webp";

const images = [
  { id: 1, src: Hero1, alt: "Image 1" },
  { id: 2, src: Hero2, alt: "Image 2" },
  { id: 3, src: Hero3, alt: "Image 3" },
  { id: 4, src: Hero4, alt: "Image 4" },
];

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Move to the next slide automatically every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="slider">
      <div
        className="slider-container"
        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
      >
        {images.map((image, index) => (
          <div className="slide" key={image.id}>
            <img src={image.src} alt={image.alt} />
          </div>
        ))}
      </div>

      <div className="dots">
        {images.map((_, index) => (
          <span
            key={index}
            className={`dot ${currentSlide === index ? "active" : ""}`}
            onClick={() => handleDotClick(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default HeroSlider;
